module.exports = __webpack_public_path__ + "img/Logo w Body.26dce71a.png";